import type { VariantProps } from 'class-variance-authority'
import type { badgeVariants } from '@/components/ui/badge'
import type { HubStatus } from '@/types/linearClient'

type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>['variant']>

export const HUB_STATUS_ORDER: HubStatus[] = ['logged', 'planned', 'scheduled', 'waiting', 'in_development', 'released', 'cancelled']
export const OPEN_HUB_STATUSES: HubStatus[] = ['logged', 'planned', 'scheduled', 'waiting', 'in_development']

const LABELS: Record<HubStatus, string> = {
  logged: 'Logged, not yet planned',
  planned: 'Planned',
  scheduled: 'Scheduled',
  waiting: 'Waiting on',
  in_development: 'In development',
  released: 'Released to the client',
  cancelled: 'Cancelled',
}

export const hubStatusLabel = (status: HubStatus, clientName: string) => (status === 'waiting' ? `Waiting on ${clientName}` : LABELS[status])

export const hubStatusVariant: Record<HubStatus, BadgeVariant> = {
  logged: 'neutral',
  planned: 'secondary',
  scheduled: 'info',
  waiting: 'warning',
  in_development: 'default',
  released: 'success',
  cancelled: 'outline',
}
